import React, { lazy } from "react";
import Loadable from "components/shared/loadable";

const ScanCardPage = Loadable(lazy(() => import("pages/scanCard")));

const PublicRoutes = {
    path: "/user/:userId",
    element: <ScanCardPage />, // No authentication or MainLayout here

};

export default PublicRoutes;
